<template>
    <div class="com-mid-content text-white">
        <div style="margin-top: 20px;">
            <BlockBox title="六个一指标雷达图" enTitle="Six-One Radar Chart" height="596" :hasTitle="false">
                <template #content>
                    <div class="radarContainer" style="padding:10px;box-sizing: border-box;position:relative;overflow: hidden;">
                        <div class="radarBg"></div>
                        <div id="chartRadar" style="height:576px;position:relative;z-index:1;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="趋势动态" enTitle="Trend Dynamics" height="339" titleType="right">
                <template #titleLabel>
                    <div class="trendFilter">
                        <el-select v-model="filterType" size="mini" style="width:100px;">
                            <el-option label="全市" value="city"></el-option>
<!--                            <el-option label="全区" value="district"></el-option>-->
                        </el-select>
                    </div>
                </template>
                <template #content>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div id="chartTrend" style="height:300px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import echartMixins from "@/utils/resizeMixins";
    import BlockBox from '@/views/components/blockBox'
    import { cityCenterData } from "@/api/api";
    
    export default {
        name: "cityMidContent",
        components: {
            BlockBox
        },
        mixins: [echartMixins],
        data() {
            return {
                item: {},
                filterType: 'city',
                indexList: [
                    { name: '创新作品', value: 65 },
                    { name: '研学旅行', value: 45 },
                    { name: '精彩演说', value: 55 },
                    { name: '美观汉字', value: 70 },
                    { name: '艺术特长', value: 50 },
                    { name: '运动习惯', value: 80 },
                ],
                trendData: {
                    dates: ['03/02', '03/08', '03/16', '03/22', '03/30', '04/05', '04/13', '04/19', '04/27', '05/03'],
                    evaluationCount: [400, 650, 520, 510, 450, 300, 380, 400, 380, 100],
                    activityCount: [50, 80, 60, 55, 45, 30, 40, 45, 42, 15]
                },
                timerMid: null,
            }
        },
        mounted() {
            this.changeData();
            this.timerMid = setTimeout(() => {
                this.changeData();
            }, 60000);
        },
        beforeDestroy() {
            clearTimeout(this.timerMid);
        },
        methods: {
            async changeData() {
                try {
                    const res = await cityCenterData();
                    if (res && res.data) {
                        this.item = res.data;
                        if (res.data.indexList) {
                            this.indexList = res.data.indexList;
                        }
                        if (res.data.useList) {
                            let useList= res.data.useList;
                            let taskList= res.data.taskList;
                            let dates=[];
                          let evaluationCount=[];
                          let activityCount=[];
                            useList.forEach(obj=>{
                              dates.push(obj.name);
                              evaluationCount.push(obj.value);
                            })
                            taskList.forEach(obj=>{
                              activityCount.push(obj.value);
                            })
                          this.trendData={
                            dates: dates,
                            evaluationCount:evaluationCount,
                            activityCount: activityCount
                          }
                        }
                    }
                } catch (e) {
                    console.log('使用默认数据');
                }
                this.$nextTick(() => {
                    this.drawRadar();
                    this.drawTrend();
                });
            },
            drawRadar() {
				console.log(echarts)
                this.chart = this.$echarts.init(document.getElementById("chartRadar"));
                // const colors = ['#ff9944', '#7766ff', '#44aaff', '#88ff99', '#33eeff', '#ddff44'];
                let maxNum=0;
                this.indexList.forEach((obj)=>{
                  if(obj.value>maxNum){
                    maxNum=obj.value;
                  }
                });
                let option = {
                    radar: {
                        indicator: this.indexList.map(item => ({
                            name: item.name,
                            max: maxNum
                        })),
                        shape: 'polygon',
                        splitNumber: 4,
                        radius: '75%',
                        center: ['50%', '50%'],
                        name: {
                            textStyle: {
                                color: "#c1f8ff",
                                fontSize: 22,
                                fontWeight: 'bold'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(100, 180, 255, 0.2)'
                            }
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                color: ['rgba(20, 60, 120, 0.1)', 'rgba(20, 60, 120, 0.2)']
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(100, 180, 255, 0.3)'
                            }
                        }
                    },
                    series: [{
                        name: '六个一指标',
                        type: 'radar',
                        data: [{
                            value: this.indexList.map(item => item.value),
                            name: '指标得分',
                            areaStyle: {
                                color: {
                                    type: 'radial',
                                    x: 0.5,
                                    y: 0.5,
                                    r: 0.5,
                                    colorStops: [{
                                        offset: 0,
                                        color: 'rgba(0, 200, 255, 0.4)'
                                    }, {
                                        offset: 1,
                                        color: 'rgba(0, 100, 200, 0.1)'
                                    }]
                                }
                            },
                            lineStyle: {
                                color: '#00c8ff',
                                width: 2
                            },
                            symbol: 'circle',
                            symbolSize: 6,
                            itemStyle: {
                                color: '#00c8ff'
                            }
                        }]
                    }]
                };
                this.chart.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart.resize();
                });
            },
            drawTrend() {
                this.chart2 = this.$echarts.init(document.getElementById("chartTrend"));
                let option = {
                    grid: {
                        left: '3%',
                        right: '3.5%',
                        bottom: '15%',
                        top: 30,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['新增评价数', '新增作品数'],
                        textStyle: {
                            color: 'rgba(255,255,255,0.7)',
                            fontSize: 11
                        },
                        top: 5,
                        right: 10,
                        itemWidth: 12,
                        itemHeight: 8
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisTick: {
                            show: false,
                        },
                        data: this.trendData.dates,
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: 10
                            },
                            rotate: 30
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: ['rgba(45,163,255,0.1)']
                            },
                            show: true
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#2da3ff'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: 10
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: ['rgba(45,163,255,0.1)']
                            },
                            show: true
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#ffffff',
                                fontSize: 10
                            }
                        }
                    },
                    series: [{
                        name: '新增评价数',
                        type: 'line',
                        smooth: true,
                        data: this.trendData.evaluationCount,
                        showSymbol: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        itemStyle: {
                            color: '#03DBF4'
                        },
                        lineStyle: {
                            color: '#03DBF4',
                            width: 2
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(3, 219, 244, 0.3)',
                                }, {
                                    offset: 1,
                                    color: 'rgba(3, 219, 244, 0)'
                                }],
                                global: false,
                            }
                        },
                    }, {
                        name: '新增作品数',
                        type: 'line',
                        smooth: true,
                        data: this.trendData.activityCount,
                        showSymbol: true,
                        symbol: 'circle',
                        symbolSize: 5,
                        itemStyle: {
                            color: '#f7cc08'
                        },
                        lineStyle: {
                            color: '#f7cc08',
                            width: 2
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(247, 204, 8, 0.3)',
                                }, {
                                    offset: 1,
                                    color: 'rgba(247, 204, 8, 0)'
                                }],
                                global: false,
                            }
                        },
                    }]
                };
                this.chart2.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart2.resize();
                });
            }
        }
    }
</script>

<style lang="scss">
    .com-mid-content {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;

        .trendFilter {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 10px;
        }

        .radarContainer {
            .radarBg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 700px;
                height: 700px;
                background: url('~@/assets/img/xz001.png') no-repeat center center;
                background-size: contain;
                animation: rotateBg 20s linear infinite;
                opacity: 0.6;
                pointer-events: none;
				
            }
        }

        @keyframes rotateBg {
            0% {
                transform: translate(-50%, -50%) rotate(0deg);
            }
            100% {
                transform: translate(-50%, -50%) rotate(360deg);
            }
        }
    }
</style>
